import { Enums } from '../common/enums'

import { IJsonSerializable } from '../util/interfaces'

import { OpIssueStatus } from '../core/op-issue-status'

import { TypeHelper } from '../../helpers/type-helper'

export class OpIssueStatusFlow implements IJsonSerializable {

    // Members

    public issueStatus: OpIssueStatus = null
    public changeStatus: OpIssueStatus[] = []

    // Members


    // Ctor

    public constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End


    // IJsonSerializable Implementation
    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {

            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                this.issueStatus = opObj.IssueStatus != null ? new OpIssueStatus(opObj.I) : null
                this.changeStatus = opObj.ChangeStatus != null ? opObj.C.map((issueStatusObj: any) => new OpIssueStatus(issueStatusObj)) : null
            } 
            else {
                this.issueStatus = opObj.IssueStatus != null ? new OpIssueStatus(opObj.IssueStatus) : null
                this.changeStatus = opObj.ChangeStatus != null ? opObj.ChangeStatus.map((issueStatusObj: any) => new OpIssueStatus(issueStatusObj)) : null
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                I: this.issueStatus != null ? this.issueStatus.toJSON(true) : null,
                C: this.changeStatus != null ? this.changeStatus.map((issueStatus: OpIssueStatus) => issueStatus.toJSON(compressed)) : null,
            }

            TypeHelper.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        } 

        return {
            IssueStatus: this.issueStatus != null ? this.issueStatus.toJSON() : null,
            ChangeStatus: this.changeStatus != null ? this.changeStatus.map((issueStatus: OpIssueStatus) => issueStatus.toJSON(compressed)) : null
        }
    }

    // IJsonSerializable Implementation End
}